import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { FileHashPipe } from '../../pipes/file-hash.pipe';

/**
 * File icons are available in an icon pack: https://fileicons.org/
 */
@Component({
  selector: 'procure-file-icon',
  templateUrl: './file-icon.component.html',
  styleUrl: './file-icon.component.scss',
  imports: [FileHashPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileIcon {
  readonly extension = input<string>();

  readonly iconUrl = computed(
    () => `/assets/icons/${this.detectIconUrl()}.svg`,
  );

  private detectIconUrl(): string {
    const extension = this.extension();

    if (!extension) {
      return 'blank';
    }

    const mapping = Object.entries({
      xlsx: ['xlm', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx'],
      docx: ['doc', 'docb', 'docm', 'docx', 'dot', 'dotm', 'dotx'],
      pptx: ['pps', 'ppsx', 'ppt', 'pptm', 'pptx'],
      jpg: ['jpg', 'jpeg'],
      tiff: ['tif', 'tiff'],
      wmf: ['wmf', 'wmz'],
      pdf: ['pdf'],
      zip: ['zip'],
      png: ['png'],
      gif: ['gif'],
      tmp: ['tmp'],
      msg: ['msg'],
      eml: ['eml'],
      rtf: ['rtf'],
      rar: ['rar'],
      html: ['html', 'htm'],
      mp4: ['mp4'],
      rfc: ['rfc822'],
    }).reduce(
      (acc, [key, values]) => {
        values.forEach((value) => {
          acc[value] = key;
        });

        return acc;
      },
      {} as Record<string, string>,
    );

    return mapping[extension.toLowerCase()] || 'blank';
  }
}
